import { useQuery } from "@tanstack/react-query";
import { DataLakeQuery } from "@graylog/enterprise-api";
import { INITIAL_PAGE, PAGE_SIZE, DATA_LAKE_PREVIEW_QUERY_KEY } from "data-lake/preview/Constants";
const fetchActiveSearch = () => DataLakeQuery.activeQuery(INITIAL_PAGE, PAGE_SIZE);
const useFetchActiveSearch = (enabled = true) => useQuery({
  queryKey: [DATA_LAKE_PREVIEW_QUERY_KEY, "active-query"],
  queryFn: fetchActiveSearch,
  retry: 0,
  enabled
});
export default useFetchActiveSearch;
